type NodeValue<V> = {
  key: string;
  value: V;
};

export class Graph<V, T extends NodeValue<V>> {
  private graph = new Map<string, T[]>();

  addEdge(key: string, edge: T): void {
    if (!this.graph.has(key)) {
      this.graph.set(key, []);
    }
    this.graph.get(key)!.push(edge);
  }

  bfs(start: string, target: string, fn: (value: V, node: T) => V, initializeValue: V): V | null {
    const queue: NodeValue<V>[] = [{ key: start, value: initializeValue }];
    const visited = new Set<string>();

    while (queue.length > 0) {
      const { key, value } = queue.shift()!;
      visited.add(key);

      for (const node of this.graph.get(key) || []) {
        if (visited.has(node.key)) {
          continue;
        }

        const newValue = fn(value, node);
        if (node.key === target) {
          return newValue;
        }

        queue.push({ key: node.key, value: newValue });
      }
    }

    return null;
  }
}
